import axios from '../AxiosInstance';
import { getApiUrl } from '../../utils/ApiUtils';

// Employee-data summary for the company's subject-access review.
export const exportEmployeeData = (companyId, employeeId) =>
  axios.get(
    getApiUrl(`${companyId}/hr/employees/${employeeId}/gdpr/export`),
    { withCredentials: true },
  );

export const previewEmployeeErasure = (companyId, employeeId) =>
  axios.get(getApiUrl(`${companyId}/hr/employees/${employeeId}/gdpr/preview`));

// Explicit category redaction; retained data and identifiers remain visible.
export const redactEmployee = (companyId, employeeId, data) =>
  axios.post(
    getApiUrl(`${companyId}/hr/employees/${employeeId}/gdpr/redact`),
    data,
    { withCredentials: true },
  );
export const anonymizeEmployee = redactEmployee;
